import $ from 'jquery';
import {refreshUtmFields} from './form-utils.js';

export function initPollInlineComponents(root = document) {
  root.querySelectorAll('[data-inline-poll]').forEach((component) => {
    if (component.dataset.inlinePollInitialized === 'true') {
      return;
    }

    component.dataset.inlinePollInitialized = 'true';

    const formWrapper = component.querySelector('.form-wrapper');
    const formPanel = formWrapper?.querySelector('.form-panel');

    component.querySelectorAll('[data-below-the-fold-poll-selector] input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!formWrapper?.classList.contains('unfold') || !formPanel) {
          return;
        }

        $(formPanel).slideDown();

        window.setTimeout(() => {
          formWrapper.classList.remove('unfold');
          refreshUtmFields(formWrapper);
        }, 1000);
      }, {once: true});
    });
  });
}
